import React from 'react';
import { observer } from 'mobx-react-lite';
import { PlusIcon } from '@radix-ui/react-icons';
import { IconButton } from '@producer/ui-kit';

import { SaveTaskDto, Task, TaskLevel } from '../../../app/entities/task';
import { CreateTaskModal } from './create-task.modal';
import { Tooltip } from '../../../components/tooltip/Tooltip';
import { GroupHeader } from '../../../components/group-header/group-header';
import { useCurrentMember } from '../../../hooks/use-current-member';
import { TaskItem } from './task-item';
import { authStore } from '../../../core/stores/auth-store';
import { openModal } from '../../../core/modal/open-modal';

type TaskCollectionProps = {
  title: string;
  value: string;
  tasks: Task[];
  taskLevel: TaskLevel;
  getIcon?: (value: any) => React.ReactElement | null;

  /**
   * Override the default navigation when clicking on a task
   * @param taskId
   */
  onSelectTask?: (taskId: string) => void;

  /**
   * Default values to be used when creating task from the collection header
   */
  defaultValues?: Partial<SaveTaskDto>;
};

export const TaskCollection: React.FC<TaskCollectionProps> = observer(
  ({ title, value, tasks, defaultValues, taskLevel, getIcon, onSelectTask }) => {
    const currentMember = useCurrentMember();
    const isViewOnly = !currentMember || currentMember.role === 'guest';

    const handleOpenCreate = async () => {
      if (isViewOnly) {
        return authStore.setAuthorized(false);
      }

      openModal(CreateTaskModal, {
        title: 'Create task',
        project: ['step', 'project'].includes(taskLevel) ? tasks[0]?.project : undefined,
        defaultValues,
      });
    };

    return (
      <>
        <GroupHeader
          icon={getIcon && getIcon(value)}
          title={title}
          count={tasks.length}
          action={
            <Tooltip text="Create task">
              <IconButton icon={<PlusIcon />} onClick={handleOpenCreate} />
            </Tooltip>
          }
        />

        {tasks
          .sort((a: any, b: any) => (a.priority > b.priority ? -1 : 1))
          .map((task) => (
            <TaskItem key={task._id} task={task} onSelect={onSelectTask} />
          ))}
      </>
    );
  },
);
